import React from 'react';
import { Link } from 'react-router-dom';
import { TAGLINE } from '../../content/manifesto';

export function SiteFooter() {
    return (
        <footer className="ds-foot">
            <div className="ds-foot__inner">
                <div className="ds-foot__left">
                    <img src="/brand/mark-glyph-96.png" alt="" />
                    <span>
                        <span className="ds-foot__tagline">{TAGLINE}</span>
                        &copy; 2026 Agents2Agents, Inc.
                    </span>
                </div>
                <div className="ds-foot__links">
                    <Link to="/manifesto">manifesto</Link>
                    <Link to="/blog">blog</Link>
                    <a href="https://github.com/Agents2AgentsAI" target="_blank" rel="noreferrer">
                        GitHub
                    </a>
                    <a className="ds-foot__mail" href="mailto:founders@agents2agents.ai">
                        founders@agents2agents.ai
                    </a>
                </div>
            </div>
        </footer>
    );
}
